import api from '@/services/api2.service';

class GlossaryService {

    addTerm(term, language = 'all') {
        return api.
            post('/custom/vocabulary', {
                term: term,
                language: language
            });
    }

    deleteTerm(term_id) {
        return api.
             delete(`/custom/vocabulary/${term_id}`);
    }

    getTerms() {
        return api.
             get('/custom/vocabulary');
    }
}
export default new GlossaryService();